"use strict";

export default {
  required: 1,
  possible: 2,
  not_allowed: 3,
};
